import { CommonContext } from '@ssr/context'
import { compareAppVersions } from '@ssr/utils'
import { useRouter } from 'next/router'
import Head from 'next/head'
import React from 'react'

export default function MetaData(props) {
  const { metaData, __ } = React.useContext(CommonContext)
  const { page_title, page_description, page_keywords, isDev, SERVICE_DOMAIN_EXTERNAL_CN, SERVICE_DOMAIN_EXTERNAL_GLOBAL, SERVICE_DOMAIN_CLOUD_EXTERNAL_CN, SERVICE_DOMAIN_CLOUD_EXTERNAL_GLOBAL } =
    metaData

  const router = useRouter()
  const { pathname } = router

  const enableMisansFont = React.useMemo(() => {
    if (pathname.includes('/app/font-declaration')) {
      // 字体声明页面都用Misans字体
      return true
    }
    const appVersion = metaData.app_version?.replace('_dev_debug', '') || '0.0.0'
    return compareAppVersions(appVersion, '2.20.0') >= 0
  }, [metaData.app_version, pathname])

  return (
    <Head>
      <meta charSet='utf-8' />
      <meta name='viewport' content='width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover' />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
      <meta name='renderer' content='webkit' />
      <meta name='format-detection' content='telephone=no' />
      <meta name='baidu-site-verification' content='zqovJhBZoA' />
      <meta name='google-site-verification' content='z7GpiZ2RUJxWY6WZerTNV27wVcmWoQucSgUnp3k8x1M' />
      <meta name='google-site-verification' content='mqtmCO2Lqv_pP2m-kzW-I1PPeEkTPdEm-aC0n8sVtJc' />
      <meta name='facebook-domain-verification' content='rqi2ddp4vgbopcpfbbwkoumeoit2i4' />
      <link rel='preconnect' href='https://static.insta360.com' />
      {SERVICE_DOMAIN_EXTERNAL_CN && <link rel='preconnect' href={SERVICE_DOMAIN_EXTERNAL_CN} />}
      {SERVICE_DOMAIN_EXTERNAL_GLOBAL && <link rel='preconnect' href={SERVICE_DOMAIN_EXTERNAL_GLOBAL} />}
      {isDev && (
        <>
          {SERVICE_DOMAIN_CLOUD_EXTERNAL_CN && <link rel='preconnect' href={SERVICE_DOMAIN_CLOUD_EXTERNAL_CN} />}
          {SERVICE_DOMAIN_CLOUD_EXTERNAL_GLOBAL && <link rel='preconnect' href={SERVICE_DOMAIN_CLOUD_EXTERNAL_GLOBAL} />}
        </>
      )}
      <link rel='preconnect' href='https://res.insta360.com' />
      <link rel='preconnect' href='https://wassets.insta360.com' />
      <link rel='preconnect' href='https://snssdk.insta360.com' />
      <link rel='dns-prefetch' href='https://media.insta360.com' />

      {/* 元信息 */}
      <link rel='icon' type='image/x-icon' href='https://res.insta360.com/static/b8721190913876c5c9f91ee12ec8dd5f/favicon.ico' />
      <title>{page_title}</title>
      {page_keywords ? <meta key='keywords' name='keywords' content={page_keywords} /> : null}
      {page_description ? <meta key='description' name='description' content={page_description} /> : null}
      {/* itemProp */}
      <meta itemProp='name' content={page_title} />
      <meta itemProp='image' content='https://static.insta360.com/assets/storage/20190717/19c309df177cb8837a8800726378dd4c/cover.png' />
      {/* Twitter Card */}
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={page_title} />
      {page_description ? <meta name='twitter:description' content={page_description} /> : null}
      <meta name='twitter:image' content='https://static.insta360.com/assets/storage/20190717/19c309df177cb8837a8800726378dd4c/cover.png' />
      {enableMisansFont && (
        <>
          <style dangerouslySetInnerHTML={{ __html: `
            @font-face {
              font-family: 'MiSans';
              font-weight: 400;
              font-display: swap;
              src: local('MiSans Normal'), local('MiSans-Normal'), url('insta360://res.insta360.com/static/282f5e29e3ef92b817212dea77bdae3c/Misans-regular.ttf') format('truetype'),
              url('https://res.insta360.com/static/282f5e29e3ef92b817212dea77bdae3c/Misans-NormalVF.ttf') format('truetype');
            }

            @font-face {
              font-family: 'MiSans';
              font-weight: 500;
              font-display: swap;
              src: local('MiSans Medium'), local('MiSans-Medium'), url('insta360://res.insta360.com/static/d225d55c27605df9e841f0cfca3fd12f/Misans-medium.ttf') format('truetype'),
              url('https://res.insta360.com/static/d225d55c27605df9e841f0cfca3fd12f/Misans-MediumVF.ttf') format('truetype');
            }

            @font-face {
              font-family: 'MiSans';
              font-weight: 600;
              font-display: swap;
              src: local('MiSans Semibold'), local('MiSans-Semibold'), url('insta360://res.insta360.com/static/46d87b491f0a3e4290223ecf6e35b3e3/Misans-semibold.ttf') format('truetype'),
              url('https://res.insta360.com/static/46d87b491f0a3e4290223ecf6e35b3e3/Misans-SemiboldVF.ttf') format('truetype');
            }
            `}}/>
        </>
      )}
    </Head>
  )
}
